export default __webpack_public_path__ + "static/media/GalleryFirstSMCwhiteFullSize.f6f2ec27.png";